module.exports = __webpack_public_path__ + "static/media/cover.aca4c78b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/tui/cover.jpg
// module id = 59
// module chunks = 0